import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LS2PacSearchDatabaseManager } from "../managers/SearchDatabaseManager";



export const SortingControl = (function ($) {

    var containerId = LS2PAC_CONSTANTS.Ids.SearchPage.sortingControlContainer,
        id = LS2PAC_CONSTANTS.Ids.SearchPage.sortingControl,
        optionExt = null,
        sortingData = null,
        hasEvents = false;
    const removeListenerFunctions = [];

    return {
        init:        function () {
            optionExt = TLCEXT.Template("<option value=\"{value}\">{languageUtil.sortBy} {text}</option>");
            this.addListeners();
            this.addEvents();
        },
        addListeners:function () {
            const pagingGuid = TLCEventManager.addListener(TLC_CONSTANTS.Events.onPagingModelResponse, function (event) {
                if (event.success && event.data.supportsSort) {
                    sortingData = event.data.sortingData;
                    var selectBox = $("#" + id);
                    selectBox.show();
                    selectBox.prop("disabled", false);
                    selectBox.empty();
                    $.each(sortingData.sortOptions, function (index, item) {
                        selectBox.append(optionExt.populate(item));
                    });
                    selectBox.val(sortingData.sortKey);
                } else if (event.data.supportsSort == false) {
                    $("#" + id).hide();
                }

            });
            removeListenerFunctions.push(() => TLCEventManager.removeListener(TLC_CONSTANTS.Events.onPagingModelResponse, pagingGuid));

            const searchGuid = TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSearch, function (event) {
                $("#" + id).attr(LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled);
            });
            removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, searchGuid));

            const logoutGuid = TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, function (event) {
                $("#" + id).attr(LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled);
            });
            removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, logoutGuid));

            const switchGuid = TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase, function (event) {
                if (LS2PacSearchDatabaseManager.getCurrentDatabaseConfig().supportsSort) {
                    $("#" + id).show();
                } else {
                    $("#" + id).hide();
                }
            });
            removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase, switchGuid));
        },
        addEvents:   function () {
            if (hasEvents === false) {
                $("#" + containerId).on("change", "#" + id, function (event) {
                    sortingData.sortKey = event.currentTarget.value;
                    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSortSearch, {sortKey:sortingData.sortKey});
                });
                hasEvents = true;
            }
        },
        cleanup: function(){
            removeListenerFunctions.forEach((remove) => remove());
            $("#" + containerId).off("change", "#" + id);
            hasEvents = false;
        }
    }

})(jQuery);
